<template>
  <div>
    <maritimeService
      :name="heading"
      subProps="Marine industry software designed to streamline operations and improve efficiency"
    />
    <v-container>
      <v-row>
        <v-col sm="12" md="7" lg="7" class="mt-sm-20">
          <h2 class="">
            Revolutionize Vessel Communication with Our Display System
          </h2>

          <div class="pt-2 divpara">
            Keep your crew informed—no matter where they are. Our innovative
            vessel communication system delivers seamless onshore-to-offshore
            message synchronization. With just a phone-sized device that
            connects to any LED display via HDMI, you can ensure crucial
            announcements reach every crew member, even in remote cabins.
          </div>

          <div class="pt-3">
            <h3>Key Features:</h3>
          </div>
          <div class="texv pt-4">
            <div class="icon-container">
              <v-icon color="white" x-large> mdi mdi-pencil </v-icon>&nbsp;
              <span class="sicon"
                ><b>Compact & Versatile:</b> Phone-sized device that easily
                connects to any LED display with HDMI.</span
              >
            </div>
            <div class="icon-container">
              <v-icon color="white" x-large>mdi-cloud</v-icon>&nbsp;
              <span class="sicon"
                ><b>Online & Offline Sync:</b> Ensure message delivery even in
                remote areas or during network outages.</span
              >
            </div>
            <div class="icon-container">
              <v-icon color="white" x-large>mdi-cogs</v-icon>&nbsp;
              <span class="sicon"
                ><b>Easy-to-Use Web Portal:</b> Manage and schedule
                communications both onshore and offshore with our intuitive
                web-based interface.</span
              >
            </div>
            <div class="icon-container">
              <v-icon color="white" x-large>mdi-shield-check</v-icon>&nbsp;
              <span class="sicon"
                ><b>Crew-Wide Communication:</b> Broadcast messages across
                cabins, common areas, or the entire vessel.</span
              >
            </div>

            <div class="icon-container">
              <v-icon color="white" x-large>mdi-shield-check</v-icon>&nbsp;
              <span class="sicon"
                ><b>Plug-and-Play Installation:</b> No complex setup
                required—simply connect the device and start sharing
                updates.</span
              >
            </div>
          </div>

          <div class="pt-3">
            <h3>Why Choose Us?</h3>
          </div>

          <div class="texv">
            <div class="icon-container">
              <v-icon color="white" x-large> mdi-account-cog </v-icon>&nbsp;
              <span class="sicon"
                ><b>Reliable Communication:</b> Never miss an important message
                with real-time syncing and offline capabilities.</span
              >
            </div>
            <div class="icon-container">
              <v-icon color="white" x-large> mdi-map-marker-path </v-icon>&nbsp;
              <span class="sicon"
                ><b>Efficient Operations:</b> Reduce the need for PA
                announcements and paper notices with direct-to-display
                communication.</span
              >
            </div>
            <div class="icon-container">
              <v-icon color="white" x-large> mdi-robot </v-icon>&nbsp;
              <span class="sicon"
                ><b>Cost-Effective:</b> Affordable, scalable solution to enhance
                crew communication without the need for costly
                infrastructure.</span
              >
            </div>
          </div>

          <div class="pt-5">
            <b>Streamline Your Vessel's Communication Today</b>
            <P>
              Contact us to learn more about our affordable, scalable solution
              for modern maritime operations.
            </P>
          </div>
        </v-col>
        <v-col sm="12" md="5" lg="5"> <base-request /> </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import maritimeService from "../../components/maritime-service.vue";
export default {
  name: "IconBackgrounds",
  components: {
    maritimeService
  },

  data: () => ({ heading: "" }),
  mounted() {
    this.heading = "AI-Powered Ship Inspection";
  }
};
</script>

<style scoped>
.img {
  min-height: 200px;
}
.divpara {
  text-align: justify;
}
h1 {
  font-size: 30px;
}

@media (max-width: 960px) {
  .mt-sm-20 {
    margin-top: 150px;
    padding: 25px;
  }
}

@media (max-width: 800px) {
  .mt-sm-20 {
    margin-top: 140px;
    padding: 25px;
  }
}

@media (max-width: 600px) {
  .mt-sm-20 {
    margin-top: 155px;
    padding: 25px;
  }
}

@media (max-width: 500px) {
  .mt-sm-20 {
    margin-top: 200px;
    padding: 25px;
  }
}

@media (max-width: 400px) {
  .mt-sm-20 {
    margin-top: 220px;
    padding: 25px;
  }
}

.icon-container {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.v-icon {
  background-color: #1a237e; /* Background color for the icon */
  padding: 10px; /* Padding to make background bigger */
  border-radius: 50%; /* Makes the background circular */
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.sicon {
  margin-left: 10px;
  font-size: 18px;
}
</style>
